import { Pipe, PipeTransform } from '@angular/core';

import { contrastColor } from '../constants/constants';

@Pipe({ name: 'contrastColor' })
export class ContrastColorPipe implements PipeTransform {
  transform(parameter, value) {
    return contrastColor(parameter, value);
  }
}
